$(window).on('load resize', () => {
  x2size($('.js-x2size'))
})

x2size($('.js-x2size'))

function x2size(elem) {
  const images = elem
  const ww = $(window).width()

  images.each((i, element) => {
    let xsize = $(element).data('xsize') || 2
    if (ww <= 767) {
      xsize = $(element).data('m-size') || 2
    }
    $(element).removeAttr('width')
    $(element).attr({
      width: $(element)[0].offsetWidth / xsize,
    })
    $(element).css('opacity', 1)
  })
}
